module.exports = __webpack_public_path__ + "static/media/communication coordinator.29b9c90e.svg";